import React from 'react';
import styles from './styles.module.css';
import { useFormik } from 'formik';
import { Input } from './Components';
import { useDispatch, useSelector } from 'react-redux';
import { auth } from '../../actions/auth';
import { Link, Navigate } from 'react-router-dom';
import { version } from '../../assets/const';

export default function Auth() {
  const dispatch = useDispatch();
  const { token } = useSelector((state) => state.auth);

  const { values, errors, touched, handleChange, handleSubmit, handleBlur } = useFormik({
    initialValues: {
      username: '',
      password: '',
    },
    onSubmit: (values) => dispatch(auth(values)),
  });

  if (token) {
    return <Navigate to="/pos" />;
  }

  return (
    <div className={styles.wrapper}>
      <header className={styles.header}>
        <h1>NinSeo</h1>
      </header>
      <main>
        <form onSubmit={handleSubmit} className={styles.form}>
          <h1>Авторизация</h1>
          <Input
            name="username"
            value={values.username}
            placeholder="Логин"
            onChange={handleChange}
            onBlur={handleBlur}
          />
          <Input
            name="password"
            type="password"
            value={values.password}
            placeholder="Пароль"
            onChange={handleChange}
            onBlur={handleBlur}
          />
          <button type="submit">Вход</button>
        </form>

        <Link to="/register" className={styles.register}>
          Регистрация
        </Link>
      </main>

      <footer className={styles.footer}>
        <a href="https://nintegra.ru" target="_blank" rel="noreferrer">
          <span>www.nintegra.ru</span>
        </a>
        <div>
          <span>V {version}</span>
        </div>
      </footer>
    </div>
  );
}
